module.exports = __webpack_public_path__ + "static/media/climbing_view_1366.ae6c746d.webp";